export {
  baseMenuContentPropDefs as contextMenuContentPropDefs,
  baseMenuItemPropDefs as contextMenuItemPropDefs,
  baseMenuCheckboxItemPropDefs as contextMenuCheckboxItemPropDefs,
  baseMenuRadioItemPropDefs as contextMenuRadioItemPropDefs,
} from './base-menu.props.js';
